import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=61fafc4d&scoped=true"
import script from "./tree.vue?vue&type=script&lang=js"
export * from "./tree.vue?vue&type=script&lang=js"
import style0 from "./tree.vue?vue&type=style&index=0&id=61fafc4d&lang=less&rel=stylesheet%2Fless"
import style1 from "./tree.vue?vue&type=style&index=1&id=61fafc4d&lang=less&rel=stylesheet%2Fless&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fafc4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61fafc4d')) {
      api.createRecord('61fafc4d', component.options)
    } else {
      api.reload('61fafc4d', component.options)
    }
    module.hot.accept("./tree.vue?vue&type=template&id=61fafc4d&scoped=true", function () {
      api.rerender('61fafc4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/tree.vue"
export default component.exports